// lazysizes removed: native loading="lazy" is supported in all target browsers
// and is set on gatsby-remark-images via `loading: 'lazy'` in gatsby-config.js.

import React from "react";
import { MDXProvider } from "@mdx-js/react";
import { mdxComponents } from "./src/mdx-components";
import { ChatCfgProvider } from "./src/context/ChatCfgContext";

// gatsby-plugin-mdx v5 expects components to be provided via MDXProvider at
// the root so embedded JSX (<More>, <YoutubePlayer>, etc.) inside .md/.mdx
// files resolves to our React components.
export const wrapRootElement = ({ element }) => (
  <MDXProvider components={mdxComponents}>{element}</MDXProvider>
);

// TZ-640: provide the per-page signed chat config token to the page subtree
// (Layout → ChatAiEmbed). props.pageContext is updated by Gatsby on SPA
// navigation, so this value tracks the active page. Coexists with the
// MDXProvider wrapRootElement above (page-level vs root-level wrappers).
export const wrapPageElement = ({ element, props }) => (
  <ChatCfgProvider
    value={(props && props.pageContext && props.pageContext.chatCfg) || null}
  >
    {element}
  </ChatCfgProvider>
);

// appt-now SDK is now injected via gatsby-ssr.js with defer — loaded during
// HTML parse, executed before DOMContentLoaded, ready before React hydration.
// Removed the previous window.onload approach that bound after hydration
// and missed buttons.
